const authReducer = (state = {authData: null}, action) => {
    switch (action.type) {
        case 'LOGIN':
            localStorage.setItem('user', JSON.stringify({... action?.data}))
            return {...state, authData: action?.data}
        case 'UPDATE_USER':
            localStorage.setItem('user', JSON.stringify({... action?.data}))
            return {...state, authData: action?.data}
        case 'LOGOUT':
            localStorage.removeItem('user');
            return {...state, authData: null}
        default:
            return state;

    }
} 

export default authReducer;